import React from 'react';
import { Form, Col, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import SvgIcon from '@material-ui/core/SvgIcon';
import MaleIcon from '../../../../icons/male.svg';
import FemaleIcon from '../../../../icons/female.svg'

import './GenderButtons.scss';

const useStyles = makeStyles((theme) => ({
  buttonSelected: {
    borderColor: theme.palette.primary.main,
  },
  buttonError: {
    backgroundColor: "#A8A8A8"
  },
  styledButtonError: {
    border: '1px solid red !important',
  },
  svgIcon: {
    '& > path[class*=svg]': {
      fill: theme.palette.primary.main,
    }
  }
}));

const CheckForError = (value,error) => {
    if(value === "F" || value === "M" || value==='Female' || value==='Male')
    {
      return false;
    } else if (error && error.message){
      return true;
    }
    return false;
}

export default function GenderButtons(props) {
  
  const classes = useStyles();

  return (
    <Row className="gender">
      <Col xs={6} className="pr-1">
        <Form.Group>
          <Button
            variant="outlined"
            className={` ${(props.selectedGender === 'F' || props.selectedGender === 'Female') ? classes.buttonSelected :props.selectedGender === 'M' || props.selectedGender === 'Male'?'': props.error!=undefined?classes.styledButtonError:''}`}
            startIcon={<SvgIcon className={classes.svgIcon} color='primary' component={FemaleIcon} />}
            id="female"
            onClick={props.onClickFemale}
            fullWidth
            aria-pressed = {props.selectedGender === 'F'}
          >
            Female
          </Button>
          <span className="MuiFormHelperText-root MuiFormHelperText-contained Mui-error" id="gender-helper-text" aria-describedby="gender-helper-text" >{CheckForError(props.selectedGender,props.error) ? props.error && props.error.message : ""}</span>
        </Form.Group>
      </Col>

      <Col xs={6} className="pl-1">
        <Form.Group>
          <Button
            variant="outlined"
            className={` ${(props.selectedGender === 'M' || props.selectedGender === 'Male') ? classes.buttonSelected :props.selectedGender === 'F' || props.selectedGender === 'Female'?'': props.error!=undefined?classes.styledButtonError:''}`}
            startIcon={<SvgIcon className={classes.svgIcon} color='primary' component={MaleIcon} />}
            id="male"
            onClick={props.onClickMale}
            fullWidth
            aria-pressed = {props.selectedGender === 'M'}
          >
            Male
                  </Button>
        </Form.Group>
      </Col>
    </Row>
  );
}

GenderButtons.propTypes = {
  selectedGender: PropTypes.string.isRequired,
  onClickMale: PropTypes.func.isRequired,
  onClickFemale: PropTypes.func.isRequired,
  error: PropTypes.object,
};





// WEBPACK FOOTER //
// ./src/components/Quoters/Common/SubComponents/GenderButtons.js